export default __webpack_public_path__ + "static/media/TVSraider_Posterior.f769ceae.webp";